import React, { Component } from 'react';
import CountUp from 'react-countup';
import { dbQuery  } from "../../../../api"
import { ArrowRightCircle,  X, Check  } from 'react-feather';

import '../../../../index.scss';

class RoundAvailabilityCube extends Component {
    constructor(props) {
        super(props);
        this.qType = this.props.qType ? this.props.qType : 'number'
        this.state = {
            loading: true,
            data: 0
        }
    }

    doQuery = () => {
        if (this.props.query) {       
            dbQuery(this.props.query).then(d2 => {
                if (d2 && d2.error) {
                    console.log(d2.error);
                } else {
                    this.setState({ data: d2, loading: false});                    
                }
            });
        } else this.setState({ loading: false});                    
    };

    doLocalQuery = (round, user) => {
        var data = (round.events.length || 0);

        return data;        
    }

    componentDidMount() {
        this.doQuery();
    }

    /*
    new - , 
    open - ready to be built, 
    built - tab has been run and is waiting for manual approval, 
    posted - results have been posted and is waiting for judging assignments, 
    filled - judges have been assigned, 
    active - currently in session, 
    closed - last ballot has been submitted  
    */
    render(){
        if (this.state.loading) { return null; }
        const {round, user, tUser} = this.props;
        var competitor = null;
        var judge = null;
        round.events.forEach(event => {
            event.rooms.forEach(room => {
                if (!competitor) { competitor = room.competitors.find(x=>x.userId === user._id); }
                if (!judge) { judge = room.judges.find(x=>x.userId === user._id); }
            });
        });

        var newBG = "bg-warning"
        switch (round.status) {
            case 'released': newBG = tUser.isJudge ? "bg-primary" : "bg-warning"; break;
            case 'posted': newBG = "bg-primary"; break;
            case 'closed': newBG = "bg-danger"; break;
            default: newBG = "bg-warning"; break;
        }
        if (round.isAnnouncing) newBG = "bg-info";

        var myStatus = <small>My Status: Inactive</small>
        if (competitor) myStatus = <small>My Status: {competitor.role}</small>
        if (judge) myStatus = <small>My Status: Judging</small>

        return (
            <div className="card o-hidden widget-cards">
                <div className={`${newBG} card-body`}>
                    <div className="media static-top-widget row">
                        <div className="icons-widgets col-3">
                            
                            <div className="align-self-center text-center"><ArrowRightCircle className="font-info" /></div>

                            <span >
                                <div className="align-self-center text-center" style={{marginTop: "4px", backgroundColor: "white"}}>
                                {competitor
                                ?   <span className="badge"><Check className="font-secondary" /></span>
                                :   <span className="badge"><X className="font-warning" /></span>
                                }                            
                                </div>
                            </span>
                        </div>

                        <div className="media-body col-9">
                        {(round.status === 'posted' || round.status === 'closed' || (round.status === 'released' && tUser.isJudge)) 
                        ?
                        <span className="m-0" style={{cursor: 'pointer', textDecoration: "underline"}} onClick={() => this.props.onTitleClick ? this.props.onTitleClick() : null}>
                            <h3>{round.title}&nbsp;</h3>
                        </span>
                        :
                        <span className="m-0" >
                            <h3>{round.title}&nbsp;</h3>
                        </span>
                        }


                            <h3 className="mb-0">
                                <CountUp className="counter" end={this.doLocalQuery(round,user)} />
                                <small>   
                                    &nbsp;Events
                                </small>
                            </h3>

                            {round.status === 'posted' && <h3 className="mb-0"> {myStatus} </h3> }
                            {round.status === 'closed' && <h3 className="mb-0"> <small>Closed</small> </h3> }
                            {(round.status !== 'posted' && round.status !== 'closed') && <h3 className="mb-0"> {myStatus} </h3> }
                                             
                        </div>    
                    </div>
                </div>
            </div>    
        )
    }
}

export default RoundAvailabilityCube;